/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SaveEntraMetaRequest
 */
export interface SaveEntraMetaRequest {
    /**
     * 
     */
    applicationId?: string;
    /**
     * 
     */
    tenantId?: string;
    /**
     * 
     */
    certPassword?: string;
}

/**
 * Check if a given object implements the SaveEntraMetaRequest interface.
 */
export function instanceOfSaveEntraMetaRequest(value: object): value is SaveEntraMetaRequest {
    return true;
}

export function SaveEntraMetaRequestFromJSON(json: any): SaveEntraMetaRequest {
    return SaveEntraMetaRequestFromJSONTyped(json, false);
}

export function SaveEntraMetaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveEntraMetaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] == null ? undefined : json['applicationId'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'certPassword': json['certPassword'] == null ? undefined : json['certPassword'],
    };
}

export function SaveEntraMetaRequestToJSON(json: any): SaveEntraMetaRequest {
    return SaveEntraMetaRequestToJSONTyped(json, false);
}

export function SaveEntraMetaRequestToJSONTyped(value?: SaveEntraMetaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
        'tenantId': value['tenantId'],
        'certPassword': value['certPassword'],
    };
}

